import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WalletsPage.Wallets.TransactionsFilter', {
    title: 'Filter',
    reset: 'Reset',
    apply: 'Apply filter',
    currency: 'Currency',
    currencyPlaceholder: 'Select Currency...',
    status: 'Status',
    statusPlaceholder: 'Select Status...',
    reference: 'Reference',
    referencePlaceholder: 'Enter Reference...',
    date: 'Date',
    amount: 'Amount',
    from: 'from',
    to: 'to',
    datePlaceholder: 'Select Date...',
    amountPlaceholder: 'Enter Amount...',
});
